import { createContext, useContext } from 'react';

const ApiContext = createContext();

export const useApi = () => useContext(ApiContext);

const API_BASE = 'https://api.quiz.xn--am-yja.org/api';

export const ApiProvider = ({ children }) => {
    const getAuthHeaders = () => {
        const token = localStorage.getItem('qztkn');
        return token ? { Authorization: `Bearer ${token}`, "x-api-key": "FGSAPIKEY" } : {};
    };

    const getQuizBySlug = async (slug) => {
        const userId = localStorage.getItem('quiz_uid');
        const res = await fetch(`${API_BASE}/quizzes/${slug}`, {
            headers: {
                ...getAuthHeaders(),
                "qiu": userId
            }
        });
        if (!res.ok) throw new Error('Error al obtener el quiz');
        return res.json();
    };

    const submitResponse = async ({ templateId, responses }) => {
        const userId = localStorage.getItem('quiz_uid');
        const res = await fetch(`${API_BASE}/quizzes/submit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders(),
            },
            body: JSON.stringify({ templateId, userId, responses }),
        });
        console.log(res);
        if (!res.ok) throw new Error('Error al enviar respuestas');
        return res.json();
    };

    const login = async ({ email, password }) => {
        const res = await fetch(`${API_BASE}/auth`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password }),
        });

        if (!res.ok) throw new Error('Credenciales inválidas');
        return await res.json();
    };

    return (
        <ApiContext.Provider value={{ getQuizBySlug, submitResponse, login }}>
            {children}
        </ApiContext.Provider>
    );
};